let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("11DLa")).then(() => parcelRequire('lklBt'));